import React from 'react';


import { compactImage } from './ColorOption';

const ShopifyImage = ({ image }) => {

    if (!image) return null

    return (
            <img src={compactImage(image?.src, 'medium')} alt={image.altText} />
    )
}

export default ShopifyImage